const getDataListItemWidth = (maxWidths) => {
  const pixelCounts = Object.values(maxWidths).reduce((a, b) => a + b + 24, 40)
  return `max(${pixelCounts}px, 100%)`
}

export default getDataListItemWidth
